import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#152E52',
        secondary: '#DEE2E3',
        golden: '#BDAD7D',
        darken: '#323C3B',
        error: '#E50040',
        success: '#2FCC60',
        'light-grey': '#4B4B4B',
        'bg-grey': '#E8E8E8',
        'accent-grey': '#F8F8F8',
      },
    },
  },
  lang: {
    locales: {
      en: {
        noDataText: 'Brak elementów do wyświetlenia',
      },
    },
  },
});
